<template>
  <div class="touch-painting-detail" :style="{ height: windowHeight + 'px' }">
    <div class="touch-painting-detail__close" @click="close()">
      <svgicon
        class="icon-close"
        icon="icon-close"
        width="14"
        height="14"
      ></svgicon>
    </div>
    <div
      class="sliding-area"
      :style="{
        transform: slideOpen
          ? 'translateY(' + (-contentHeight + 150) + 'px)'
          : 'translateY(0px)'
      }"
    >
      <div
        class="touch-painting-detail__image-container"
        :style="{ height: windowHeight - 150 + 'px' }"
      >
        <img
          :src="`${assetsPaths.imagesPath}${
            $tvaMq === 'mobile' ? '500' : '1280'
          }/${info.id}.jpg`"
        />
      </div>
      <div class="content-area" ref="contentArea">
        <div
          class="touch-painting-detail__details__intro"
          v-touch:swipe="handleSlide"
        >
          <div class="info__name">{{ info.titolo_opera }}</div>
          <div class="info__author">{{ info.autore }}</div>
        </div>
        <div class="touch-painting-detail__details__overscroll">
          <div class="info__year">{{ info.anno }}</div>
          <div class="info__place">
            {{ formattedInfoPlace }}
          </div>
          <a
            v-if="info['link.opera1(collection)']"
            class="info__link"
            :href="info['link.opera1(collection)']"
            target="_blank"
          >
            {{ content.details.link }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "../../compiled-icons/icon-close";
import assetsPaths from "@/assets/assetsPaths.js";

export default {
  mounted() {
    this.getWindowHeight();
    this.getContentHeight();
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      assetsPaths,
      slideOpen: false,
      contentHeight: 0,
      windowHeight: 0
    };
  },
  computed: {
    relatedPaintings() {
      return this.getAuthors[this.info.autore];
    },
    content() {
      return this.$ml.get("gallery");
    },
    formattedInfoPlace() {
      const info = [
        this.info.gallery_library_archive_museum,
        this.info.city,
        this.info.country
      ]
        .filter(Boolean)
        .join(", ");

      return info;
    },

    ...mapGetters(["getAuthors"])
  },
  props: ["info"],
  methods: {
    close() {
      this.$emit("close");
    },
    getContentHeight() {
      this.contentHeight = this.$refs.contentArea.clientHeight;
    },
    handleSlide() {
      console.log("ao ao");
      this.slideOpen = !this.slideOpen;
    },
    getWindowHeight() {
      let vh = window.innerHeight * 0.01;
      this.windowHeight = vh * 100;

      window.addEventListener("orientationchange", () => {
        let vh = window.innerHeight * 0.01;
        this.windowHeight = vh * 100;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.touch-painting-detail {
  background: #573c46;
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: auto;
  position: fixed;
  width: 100vw;
  z-index: $z-g;
  overflow: hidden;
  .sliding-area {
    transition: all 0.6s cubic-bezier(0.65, 0.05, 0.36, 1);
  }
  &__close {
    background-color: $white;
    border-radius: 50%;
    height: 40px;
    position: fixed;
    right: 15px;
    top: 15px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: $z-c;
    .icon-close {
      fill: $black;
    }
  }
  &__image-container {
    align-items: center;
    display: flex;
    justify-content: center;
    max-width: 100%;
    background-color: black;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
  &__details {
    &__intro {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 30px 30px;
      position: relative;
      border-bottom: 1px solid $white-50;
      min-height: 150px;
      &::after {
        content: "";
        position: absolute;
        width: 41px;
        height: 2px;
        top: 10px;
        left: 50%;
        transform: translate(-50%, 0);
        background-color: $white-50;
      }
      .info {
        &__name {
          color: $white;
          @include HH3;
          margin-bottom: 15px;
          text-align: center;
        }
        &__author {
          color: $white;
          @include pS;
        }
      }
    }
    &__overscroll {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 30px 60px;
      .info {
        &__year {
          color: $white;
          @include pM;
          margin-bottom: 15px;
        }
        &__place {
          color: $white;
          @include pS;
          margin-bottom: 15px;
          text-align: center;
        }
        &__link {
          @include pS;
          color: $white;
        }
        &__rights {
          color: $white;
          @include DidaS;
          position: absolute;
          bottom: 50px;
          max-width: 200px;
        }
      }
    }
  }
}
</style>
